// import { optionSelectAll } from "@/utils/commonUtils";

const chiTietChucVu = state => state.chiTietDonVi;
const danhSachChucVuPhanTrang = state => state.danhSachChucVuPhanTrang;
const danhSachChucVu = state => state.danhSachChucVu;

export default {
  chiTietChucVu,
  danhSachChucVuPhanTrang,
  danhSachChucVu
};
